import React, { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import InviteUserModal from './InviteUserModal';
import { useAsyncState } from '@/utils/hooks';
import { getProfileAcl } from '@/services/profiles';

type Props = {
    // OwnProps
};

const UnitSettings: React.FC<Props> = () => {
    const profileId = useSelector((state: IState) => state.global.activeProfile!.id);
    const unitName = useSelector((state: IState) => state.buyer.projectData!.unitName);
    const [isOpen, setIsOpen] = useState(false);
    const [acl, , reload] = useAsyncState(() => getProfileAcl(profileId), [profileId], []);

    // const cancelInvitation = async (inviteId: number) => {
    //     await cancelProfileInvite(inviteId);
    //     Toast.info(<Trans>Cancelled invitation</Trans>);
    //     reload();
    // };
    return (
        <>
            <h5>
                <Trans>Unit</Trans>
            </h5>
            <div className="form columns-1 labels-25">
                <div>
                    <label>
                        <Trans>Unit name</Trans>
                        <input disabled value={unitName} className="form-control-plaintext" />
                    </label>
                </div>
            </div>
            <h5>
                <Trans>Users</Trans>
            </h5>
            <div className="form columns-1 labels-25">
                {acl.map((user) => (
                    <div key={user.displayName}>
                        <label>
                            {user.displayName}
                            <div className="form-control-plaintext">
                                {user.status}
                                {/* {user.status === MemberStatus.Invited && (
                                    <Button onClick={() => cancelInvitation(user.inviteId!)} color="link">
                                        <Trans>Cancel invitation</Trans>
                                    </Button>
                                )} */}
                            </div>
                        </label>
                    </div>
                ))}
            </div>
            {/* <Button onClick={() => setIsOpen(true)} color="link" size="xsmall" icon={faPlus}>
                <Trans>Invite user</Trans>
            </Button> */}
            <InviteUserModal reload={reload} isOpen={isOpen} toggle={() => setIsOpen(false)} />
        </>
    );
};

export default UnitSettings;
